export default "__VITE_ASSET__d35cfa88__"